import React from "react";
import { Paper } from "..";
import { Box, Typography } from "@mui/material";
import classes from "./index.module.css";

const ContentSurface = ({ title, children, header, styles = {} }) => {
  return (
    <Paper sx={{ mt: 4, p: 3, ...styles.paper }} className={classes.container}>
      <Box className={classes.header} sx={styles.header}>
        <Typography variant="h4" className={classes.title}>
          {title}
        </Typography>
        {header}
      </Box>
      <Box className={classes.content} sx={styles.content}>
        {children}
      </Box>
    </Paper>
  );
};

export default ContentSurface;
